import * as z from "zod";

/** A Space's own coding-agent connection. The key is write-only and never returned. */
export const SpaceCloudAgentStatusSchema = z.object({
  /** Only the Space owner may connect or disconnect a key. */
  canManage: z.boolean(),
  connected: z.boolean(),
  /** A self-hosted server, when one is set. */
  baseUrl: z.string().nullable(),
});
export type SpaceCloudAgentStatus = z.infer<typeof SpaceCloudAgentStatusSchema>;

export const SpaceCloudAgentConnectInputSchema = z.object({
  apiKey: z.string().trim().min(1).max(4096),
  baseUrl: z.string().trim().max(2048).optional(),
});
export type SpaceCloudAgentConnectInput = z.infer<typeof SpaceCloudAgentConnectInputSchema>;
